import React from "react";
const SelectedEventContext = React.createContext();
export default SelectedEventContext;
